<mat-toolbar mat-dialog-title>{{ 'Form_changed_tr' | translate }}</mat-toolbar>

<div mat-dialog-content style="padding: 1em 1em">{{ 'Discard_or_continue_edit_tr' | translate }}</div>

<dialog-form-actions>
  <button type="button" [mat-dialog-close]="true" color="primary" mat-raised-button>{{ 'discard_tr' | translate }}</button>
  <button type="button" [mat-dialog-close]="false" mat-raised-button>{{ 'edit_tr' | translate }}</button>
</dialog-form-actions>
